import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import {
  AcademicPeriod,
  CreateAcademicPeriodDto,
  UpdateAcademicPeriodDto
} from '../interfaces/academic-period'
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AcademicPeriodService {

  private readonly baseURL = environment.BASE_URL;
  private readonly http = inject(HttpClient)

  private readonly api = `${this.baseURL}/admin/academic-periods`

  getAcademicPeriods(): Observable<any> {
    return this.http.get<any>(this.api)
  }

  getActivePeriod(): Observable<any> {
    return this.http.get<any>(`${this.api}/active`)
  }

  createPeriod(data: CreateAcademicPeriodDto): Observable<any> {
    return this.http.post<any>(this.api, data)
  }

  updatePeriod(id: number, data: UpdateAcademicPeriodDto): Observable<any> {
    return this.http.put<any>(`${this.api}/${id}`, data)
  }

  deletePeriod(id: number): Observable<any> {
    return this.http.delete<any>(`${this.api}/${id}`)
  }

  activatePeriod(id: number): Observable<any> {
    return this.http.put<any>(`${this.api}/${id}/activate`, {})
  }

}
